<template>
  <div class="freightInquiry">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="getPlaceHolder()"
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
        <van-col class="colItem2">
          <div :class="isFilter() ? 'isFilter' : ''">
            <span @click="showFilter = true">{{ $t.meta.filter }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-tabs
      v-model="menuState"
      @change="stateChanged"
      title-active-color="#009ed4"
      color="#009ed4"
      swipeable
    >
      <van-tab
        v-for="(menu, index) in menuList"
        :key="index"
        :title="menu.title + (menu.count > 0 ? ' ' + menu.count : '')"
        :name="menu.name"
        :disabled="loading ? true : false"
      >
        <van-list
          class="list"
          v-model="loading"
          :finished="finished"
          :finished-text="$t.meta.noMore"
          :error.sync="error"
          :error-text="errorText"
          @load="getList(page + 1)"
        >
          <template v-if="menuState == 1">
            <div
              class="detail"
              v-for="(item, index) in tableData"
              :key="index"
              @click="gotoDetail(item.FPId)"
            >
              <div class="left">
                <van-image
                  width="50"
                  height="50"
                  fit="cover"
                  round
                  :src="imgUrlFilter(item.NationalFlagPicture)"
                ></van-image>
              </div>
              <div class="right">
                <div class="country">{{ item.CountryName }}</div>
              </div>

              <div class="arrow">
                <van-icon name="arrow" />
              </div>
            </div>
          </template>
          <template v-if="menuState == 2">
            <div class="list-container" v-for="(item, index) in tableData" :key="index">
              <div class="list-item">
                {{ $t.freightInquiry.supplier }}：{{ item.CompanyName }}
              </div>
              <div class="list-item">
                {{ $t.freightInquiry.area }}：{{ item.RegionName }}
              </div>
              <div class="list-item">{{ $t.meta.country }}：{{ item.CountryName }}</div>
              <div class="list-item">{{ $t.meta.city }}：{{ item.CityName }}</div>
              <div class="list-item">
                {{ $t.freightInquiry.bcName }}：{{ item.BCName }}
              </div>
              <div class="list-item">
                {{ $t.freightInquiry.updateTime }}：{{ item.CreateTime }}
              </div>
              <div class="buttons">
                <van-button
                  class="primary-btn"
                  size="small"
                  type="primary"
                  @click="gotoQuotationDetail(item.SQId)"
                  >{{ $t.meta.view }}
                </van-button>
              </div>
            </div>
          </template>
        </van-list>
      </van-tab>
    </van-tabs>

    <van-popup
      v-model="showFilter"
      position="bottom"
      :style="{ height: '80%', width: '100%' }"
    >
      <div class="popup-header">{{ $t.meta.allFilter }}</div>
      <van-form>
        <template v-if="menuState == 1">
          <div class="radio-label">{{ $t.meta.searchType }}</div>
          <van-radio-group v-model="searchType" direction="horizontal">
            <van-radio
              :name="item.value"
              v-for="(item, index) in searchTypeOptions"
              :key="index"
              >{{ item.text }}</van-radio
            >
          </van-radio-group>
        </template>
        <template v-if="menuState == 2">
          <van-field
            clickable
            readonly
            :value="areaName"
            :label="$t.freightInquiry.area"
            :placeholder="$t.meta.select"
            @click="onShowEmit('showFreightInquiryArea')"
          />

          <van-field
            clickable
            readonly
            :value="countryName"
            :label="$t.freightInquiry.countryName"
            :placeholder="$t.meta.select"
            @click="onShowEmit('showFreightInquiryCountry')"
          />

          <van-field
            clickable
            readonly
            :value="bcName"
            :label="$t.freightInquiry.bcName"
            :placeholder="$t.meta.select"
            @click="onShowEmit('showFreightInquiryBc')"
          />
        </template>
      </van-form>
      <div class="popup-footer">
        <van-button class="reset" type="info" block square @click="filterReset">{{
          $t.meta.reset
        }}</van-button>

        <van-button class="confirm" type="primary" block square @click="filterSubmit">{{
          $t.meta.confirm
        }}</van-button>
      </div>
    </van-popup>

    <option-list
      event="showFreightInquiryArea"
      :options="areaList"
      @onSelect="areaConfirm"
    ></option-list>

    <option-list
      event="showFreightInquiryCountry"
      :options="countryList"
      @onSelect="countryConfirm"
    ></option-list>

    <option-list
      event="showFreightInquiryBc"
      :options="bcList"
      @onSelect="bcConfirm"
    ></option-list>
  </div>
</template>
<script>
import OptionList from "@components/optionList/OptionList.vue";
import Vue from "vue";
import {
  Image,
  Tab,
  Tabs,
  List,
  Form,
  Button,
  Radio,
  RadioGroup,
  Row,
  Col,
  Popup,
  Icon,
  Search,
  Field,
} from "vant";
Vue.use(Image)
  .use(Tab)
  .use(Tabs)
  .use(List)
  .use(Form)
  .use(Button)
  .use(Radio)
  .use(RadioGroup)
  .use(Row)
  .use(Col)
  .use(Popup)
  .use(Icon)
  .use(Search)
  .use(Field);

export default {
  name: "freightInquiry",
  components: {
    OptionList,
  },
  data() {
    return {
      menuState: this.$route.query.state
        ? this.$route.query.state
        : parseInt(localStorage.getItem("MenuState")),
      menuList: [
        {
          title: this.$t.freightInquiry.tab1,
          name: 1,
          count: 0,
        },
        {
          title: this.$t.freightInquiry.tab2,
          name: 2,
          count: 0,
        },
      ],
      page: 0,
      pageSize: 10,
      tableData: [],
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //filter
      showFilter: false,
      searchText: "",
      searchType: 1,
      searchTypeOptions: [
        {
          text: this.$t.freightInquiry.countryName,
          value: 1,
        },
        {
          text: this.$t.freightInquiry.cargoCategory,
          value: 2,
        },
      ],
      countryName: "",
      countryId: null,
      countryList: [],
      areaName: "",
      areaValue: null,
      areaList: [],
      bcName: "",
      bcValue: null,
      bcList: [],
      showFreightInquiryCountry: false,
      showFreightInquiryArea: false,
      showFreightInquiryAw: false,
      showFreightInquiryBc: false,
    };
  },
  watch: {
    menuState() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
      this.getList(1);
    },
  },
  created() {
    this.getOptions();
  },
  methods: {
    bcConfirm(e) {
      this.bcName = e.text;
      this.bcValue = e.value;
      this.showFreightInquiryBc = false;
      this.$forceUpdate();
    },
    areaConfirm(e) {
      this.areaName = e.text;
      this.areaValue = e.value;
      this.showFreightInquiryArea = false;
      this.$forceUpdate();
    },
    countryConfirm(e) {
      this.countryName = e.text;
      this.countryId = e.value;
      this.showFreightInquiryCountry = false;
      this.$forceUpdate();
    },
    onShowEmit(emit) {
      this.$bus.$emit(emit, true);
    },
    getOptions() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        Promise.all([this.getCountryList(), this.getOverseasAgentServiceSetting()])
          .then((success) => {
            if (success) {
              resolve(true);
            }
            this.$commonMethod.hideLoading();
          })
          .catch(() => {
            this.$commonMethod.hideLoading();
          });
      });
    },
    getOverseasAgentServiceSetting() {
      return new Promise((resolve) => {
        this.$api.supplier
          .getOverseasAgentServiceSetting()
          .then((res) => {
            this.settings = res.data;

            var bcList = [];
            this.settings[1].forEach((item) => {
              let data = {
                text: item.BCName,
                value: item.BCId,
              };
              bcList.push(data);
            });
            this.bcList = this.$commonMethod.deepClone(bcList);

            var areaList = [];
            this.settings[3].forEach((item) => {
              let data = {
                text: item.RegionName,
                value: item.RegionId,
              };
              areaList.push(data);
            });
            this.areaList = this.$commonMethod.deepClone(areaList);

            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getCountryList() {
      return new Promise((resolve) => {
        this.$api.customerManagement
          .getCountryList()
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.CountryName + "," + item.CountryName_en,
                value: item.CountryId,
              };
              result.push(data);
            });
            this.countryList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    gotoDetail(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "freightInquiryDetail",
        name: "freightInquiryDetail",
        query: [
          {
            name: "FPId",
            value: id,
          },
        ],
      });
    },
    gotoQuotationDetail(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "customerQuotationDetail",
        name: "customerQuotationDetail",
        query: [
          {
            name: "SQId",
            value: id,
          },
        ],
      });
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    getPlaceHolder() {
      if (this.menuState == 2) {
        return this.$t.freightInquiry.companyNameKeyword;
      } else {
        var search = this.searchTypeOptions.find((c) => c.value == this.searchType);
        if (search) {
          return search.text;
        } else {
          return this.$t.meta.search;
        }
      }
    },
    onSearch() {
      this.initList();
      this.getList(1);
    },
    isFilter() {
      if (this.countryId || this.areaValue || this.bcValue) {
        return true;
      } else {
        return false;
      }
    },
    filterReset() {
      this.searchType = 1;
      this.searchText = "";
      this.countryName = "";
      this.countryId = null;
      this.areaName = "";
      this.areaValue = null;
      this.bcName = "";
      this.bcValue = null;
      this.initList();
      this.getList(1);
    },
    filterSubmit() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.showFilter = false;
      this.tableData = [];
    },
    stateChanged(state) {
      this.menuState = state;
      localStorage.setItem("MenuState", JSON.stringify(state));
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
      };
      var request = null;
      if (this.menuState == 2) {
        param.CountryId = this.countryId;
        param.RegionId = this.areaValue;
        param.BCId = this.bcValue;
        param.CompanyNameKeyword = this.searchType == 1 ? this.searchText : "";
        request = this.$api.myCustomer.getCustomerSupplierQuotationListByPage(param);
      } else {
        param.CountryName = this.searchType == 1 ? this.searchText : "";
        param.CargoCategory = this.searchType == 2 ? this.searchText : "";
        request = this.$api.onlineOrderManagement.getFreightPriceListByPage(param);
      }
      request
        .then((res) => {
          this.tableData = this.tableData.concat(res.data.Data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.page = res.meta.page;
          this.finished = this.page >= res.meta.lastPage;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.freightInquiry {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;
        .van-search__content {
          padding: 0px;
          margin-right: 10px;
          .van-cell {
            color: #969799;
            padding: 5px 8px 5px 8px;
          }
        }
      }
      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 14px;
        .isFilter {
          color: $-color-primary;
          font-weight: bold;
        }
      }
    }
  }
  .list {
    .detail {
      width: 45.5%;
      background: #fff;
      margin: 2.5% 0px 0px 2.5%;
      padding: 10px 0px 10px 0px;
      display: inline-block;
      border-radius: 10px;
      border: 1px solid #e5e5e5;
      box-shadow: 0px 2.5px 5px 0px rgba(0, 0, 0, 0.1);
      .left {
        vertical-align: middle;
        display: inline-block;
        width: 45%;
        text-align: center;
      }
      .right {
        vertical-align: middle;
        display: inline-block;
        width: 40%;
        .country {
          color: #333;
          font-size: 12px;
          font-weight: bold;
        }
      }
      .arrow {
        text-align: center;
        vertical-align: middle;
        display: inline-block;
        width: 15%;
        .van-icon {
          font-size: 14px;
          font-weight: bold;
          color: #999;
        }
      }
    }
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
      }
      .list-item:last-child {
        margin-bottom: 0px;
      }
      .buttons {
        text-align: right;
        .primary-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }
  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .van-radio-group {
    margin-bottom: 20px;
  }
  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;
    ::v-deep .van-radio__label {
      color: #646566;
    }
  }
  .van-form {
    width: 90%;
    margin: auto;
    padding-bottom: 20vw;
    .van-cell:after {
      border: none;
    }
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
  }
  .popup-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    background-color: white;
    padding-bottom: env(safe-area-inset-bottom);
    width: 100%;
    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }
    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
